@if (selectedRow) {
  <app-rental-object-improvements-form
    [row]="selectedRow"
    [currencyCode]="currencyCode"
    (completed)="onCompleted($event)"
  ></app-rental-object-improvements-form>
}
@if (!selectedRow) {
  <div>
    <div class="astral-stack-m">
      <astral-button
        variant="primary"
        size="small"
        type="button"
        icon="plus"
        labelKey="CREATE_BTN"
        (click)="createItem()"
      ></astral-button>
      <app-list-view
        [columnDefinition]="columnDefinition"
        [contextMenuDefinition]="menuDefinition"
        [itemsSource]="itemsSource"
        [preferencesKey]="'rent.rental-object-improvements.list'"
        (rowClick)="onRowClicked($event)"
      ></app-list-view>
    </div>
  </div>
}
